import { Sparkles, GitCompareArrows, Play, Square, Share2, Camera, Stamp } from "lucide-react";
import { HEAT_CATEGORIES } from "../lib/scoring";

export function ControlBar({
  category,
  onCategory,
  bloom,
  onBloom,
  compareMode,
  onCompareMode,
  tourActive,
  onTour,
  onShare,
  onSnapshot,
  onManageSeals,
}) {
  return (
    <>
      {/* Utilities — far top-right */}
      <div className="hud-utilities" data-testid="control-bar">
        <button
          className={`ctrl-toggle${bloom ? " ctrl-toggle-active" : ""}`}
          data-testid="bloom-toggle"
          onClick={() => onBloom(!bloom)}
        >
          <Sparkles size={15} strokeWidth={1.8} />
          Bloom
        </button>

        <button
          className={`ctrl-toggle${compareMode ? " ctrl-toggle-active" : ""}`}
          data-testid="compare-toggle"
          onClick={() => onCompareMode(!compareMode)}
        >
          <GitCompareArrows size={15} strokeWidth={1.8} />
          Compare
        </button>

        <button
          className={`ctrl-toggle${tourActive ? " ctrl-toggle-active" : ""}`}
          data-testid="tour-toggle"
          onClick={() => onTour(!tourActive)}
        >
          {tourActive ? (
            <Square size={14} strokeWidth={2.2} fill="currentColor" />
          ) : (
            <Play size={14} strokeWidth={2.2} fill="currentColor" />
          )}
          Tour
        </button>

        <div className="ctrl-divider" />

        <button className="ctrl-toggle ctrl-share" data-testid="share-button" onClick={onShare}>
          <Share2 size={15} strokeWidth={1.8} />
          Share
        </button>

        <button
          className="ctrl-toggle ctrl-icon"
          data-testid="snapshot-button"
          onClick={onSnapshot}
          title="Download snapshot"
        >
          <Camera size={16} strokeWidth={1.8} />
        </button>

        <button
          className="ctrl-toggle ctrl-icon"
          data-testid="manage-seals-button"
          onClick={onManageSeals}
          title="Manage university seals"
        >
          <Stamp size={16} strokeWidth={1.8} />
        </button>
      </div>

      {/* Heatmap selector — its own centered row below the header */}
      <div className="hud-heatmap" data-testid="heatmap-controls">
        <span className="ctrl-label">Heatmap</span>
        <div className="ctrl-segment">
          {HEAT_CATEGORIES.map((c) => (
            <button
              key={c.key}
              className={`seg-btn${category === c.key ? " seg-btn-active" : ""}`}
              data-testid={`heatmap-${c.key}`}
              onClick={() => onCategory(c.key)}
            >
              {c.label}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
